import React from 'react'
import { clsx } from 'clsx'

const LoadingSpinner = ({
  size = 'md',
  color = 'primary',
  className = '',
  text = null
}) => {
  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  }

  const colorMap = {
    primary: '#1f9f93',
    secondary: '#475569',
    white: '#ffffff',
    gray: 'rgba(29,38,45,.45)',
  }

  const currentColor = colorMap[color] || colorMap.primary

  return (
    <div className={clsx('flex items-center justify-center', className)}>
      <div className="flex flex-col items-center space-y-2">
        <svg
          className={clsx('animate-spin', sizeClasses[size])}
          style={{ color: currentColor }}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        {text && (
          <p className="text-sm font-bold" style={{ color: currentColor }}>
            {text}
          </p>
        )}
      </div>
    </div>
  )
}

export default LoadingSpinner
